/**
 * @generated SignedSource<<0370aaa8ba04e333015a28587009cad4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateHydrantManufacturerInput = {
  name: string;
  clientMutationId?: string | null;
};
export type createPageCreateHydrantManufacturerMutation$variables = {
  input: CreateHydrantManufacturerInput;
};
export type createPageCreateHydrantManufacturerMutationVariables = createPageCreateHydrantManufacturerMutation$variables;
export type createPageCreateHydrantManufacturerMutation$data = {
  readonly createHydrantManufacturer: {
    readonly hydrantManufacturer: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateHydrantManufacturerMutationResponse = createPageCreateHydrantManufacturerMutation$data;
export type createPageCreateHydrantManufacturerMutation = {
  variables: createPageCreateHydrantManufacturerMutationVariables;
  response: createPageCreateHydrantManufacturerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateHydrantManufacturerPayload",
    "kind": "LinkedField",
    "name": "createHydrantManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantManufacturer",
        "kind": "LinkedField",
        "name": "hydrantManufacturer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateHydrantManufacturerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateHydrantManufacturerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2e9d50ebc7a2aba7dc6e91e3dc9e883e",
    "id": null,
    "metadata": {},
    "name": "createPageCreateHydrantManufacturerMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateHydrantManufacturerMutation(\n  $input: CreateHydrantManufacturerInput!\n) {\n  createHydrantManufacturer(input: $input) {\n    hydrantManufacturer {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "84f8a4425200a490be120439a9788a27";

export default node;
